import { HandballIncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const SuspensionPopup = new PopupBuilder('Suspension', {
  incident_id: HandballIncidentId.TwoMinuteSuspension,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
